import { Constants, Fields } from '../fields/pool';

export const trackAddFilter = ({
	filterName,
	filterSelected,
}: {
	filterName: string;
	filterSelected: string | boolean;
}): Object => ({
	[Fields.Event]: Constants.EventAdd,
	[Fields.FilterName]: filterName,
	[Fields.FilterSelected]: filterSelected,
});

export const trackRemoveFilter = ({
	filterName,
	filterSelected,
}: {
	filterName: string;
	filterSelected: string | boolean;
}): Object => ({
	[Fields.Event]: Constants.EventRemove,
	[Fields.FilterName]: filterName,
	[Fields.FilterSelected]: filterSelected,
});
